import React from 'react'

import { useAuthIsAuthenticated } from '@/entities/auth'
import { getUsersProfileWebim } from '@/shared/api/generated/api'

export const useInitWebimVisitor = () => {
    const [isInitWebimVisitor, setIsInitWebimVisitor] = React.useState(false)
    const { isAuthenticated } = useAuthIsAuthenticated()

    /**
     * Заполняем webim_visitor после авторизации,
     * если пользователь полностью зарегистрирован
     */
    React.useEffect(() => {
        if (isAuthenticated && !webim_visitor?.fields?.id && !isInitWebimVisitor) {
            setIsInitWebimVisitor(true)
            getUsersProfileWebim().then((response) => {
                webim_visitor = {
                    fields: {
                        display_name: response?.fields?.name,
                        email: response?.fields?.email,
                        id: response?.fields?.id,
                        phone: response?.fields?.phone,
                        profile_url: response?.fields?.profile_url,
                        info: response?.fields?.info,
                    },
                    hash: response.hash,
                }
                if (typeof webim?.api?.onProvidedVisitorChanged == 'function') {
                    webim.api.onProvidedVisitorChanged()
                }
                setIsInitWebimVisitor(false)
            })
        }
    }, [isAuthenticated, isInitWebimVisitor])
}
